import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

/**
 * Master layanan Port Services untuk form Quotation.
 *
 * Menggantikan konstanta hardcode `port_service` di
 * features/operasional/quatation/constants/activityOptions.js, mengikuti pola
 * yang sudah dipakai Rental / Waste / Limbah / Manpower di form yang sama.
 *
 * `value` sengaja memakai kolom "Kode", bukan "PortServiceID": QoLine menyimpan
 * salinan teks di "ItemName" tanpa foreign key, dan seluruh QO lama (85 baris)
 * sudah berisi kode itu. Memakai ID akan membuat semuanya tak cocok.
 */
export const getMinPortService = createAsyncThunk(
  "PortService/getMin",
  async (_arg, thunkAPI) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "Master/PortService/getMin",
        {
          headers: {
            Authorization: "Bearer " + user.Token,
            Accept: "*/*",
          },
        }
      );
      if (response.status === 200) {
        const newObj = (response.data.data ?? []).map((item) => ({
          value: item.Kode,
          label: item.Nama,
          // Ikut dibawa untuk keperluan tampilan; yang menentukan penagihan tetap
          // backend saat JR dibuat (resolveFormulaType).
          FormulaType: item.FormulaType,
          ServiceType: item.ServiceType,
          SatuanID: item.SatuanID,
        }));
        return { data: newObj };
      }
      return thunkAPI.rejectWithValue(response.data);
    } catch (e) {
      return thunkAPI.rejectWithValue(e?.response?.data ?? { message: e.message });
    }
  }
);

const initialState = {
  message: "",
  minData: [],
  isMinFetching: false,
  isMinSuccess: false,
  isMinError: false,
  errorMessage: "",
};

export const portServiceSlice = createSlice({
  name: "portService",
  initialState,
  reducers: {},
  extraReducers: {
    [getMinPortService.pending]: (state) => {
      state.isMinFetching = true;
      return state;
    },
    [getMinPortService.fulfilled]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinSuccess = true;
      state.minData = payload.data;
      return state;
    },
    [getMinPortService.rejected]: (state, { payload }) => {
      state.isMinFetching = false;
      state.isMinError = true;
      state.errorMessage = payload?.message ?? "Gagal memuat master Port Service";
      return state;
    },
  },
});

export const portServiceSelector = (state) => state.portService;
